import { AdminApiTokenResponse } from "@shared/types/common";
import { DateTime } from "luxon";
import myJFrogUtils from "@shared/utils/myJFrogUtils.ts";

export default async () => {
  return {
    token: myJFrogUtils.generateCharString(700),
    tokenExpiry: DateTime.now().plus({ years: 1 }).toMillis(),
  } satisfies AdminApiTokenResponse;
};
